import { Middleware, RequestContext, FetchParams } from './adgang/runtime';
import { AuthService } from '../auth/AuthService';

class AddTokenMiddleware implements Middleware {
  async pre?(context: RequestContext): Promise<FetchParams | void> {
    const token = await AuthService.getAccessToken();
    if (context.init.headers !== undefined) {
      (context.init.headers as Record<string, string>).Authorization = `Bearer ${token}`;
    }

    return context;
  }
}

export default AddTokenMiddleware;
